import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizDatasource,
  WizRoot,
  WizTileList,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AddMeasureRenderer } from './compos/add-measure.renderer';
import { BaselineEngine, FeiKeyDef, KEY_KIND, MeasureVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { MultiDisplayConfig } from '../../multi-display/config/multi-display.config';
import { ALK_EVENT_TYPE } from '../../../model/enums';
import { AlkEvent } from '../../../framework/events/alk.event';
import { Model } from '../../../model/model';
import { MeasureParams } from '../../../manager/workingdata/measure.engine';


@Component({
  // popup de construction des mesures
  selector: 'add-measure-pop',
  templateUrl: './add-measure.pop.html',
})
// TODO gestion différenciée des constantes et des WeightGrid
export class AddMeasurePop extends WizBasePopUp {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
   
    if (event.key === VALUE_ENTER) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.doCancel();
    }
  }  
  
  @ViewChild('measureList', { read: WizTileList }) measureList: WizTileList; // liste des mesures disponibles
  @ViewChild('measureFilter', { read: FilterComponent }) measureFilter: FilterComponent; // filtre des mesures

  @ViewChild('descDiv') descDiv: ElementRef; // la div de détail des formules / fonctions

  protected doSaveFlag: boolean = false; // marqueur de validation des modifs (false sur cancel)

  private _model : Model = null;
  public get model(): Model {
    return this._model;
  }
  public mode: string; // le mode choisi (FIST)
  public source: MeasureVO = null; // la mesure d'origine // pour ne pas la proposer
  protected updateCallback: Function; // la callback pour retour et traitement

  public measureDS: WizDatasource<FeiKeyDef> = new WizDatasource<FeiKeyDef>([])
    .setItemCodeField('fullCode')
    .setSelectionMode('single')
    .setFilter(this.measureFilterFunc.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build(); // la collection de mesures disponibles

  public currentDescHtml: SafeHtml = ''; // le contenu de la div de description
  public currentMeasure: FeiKeyDef = null;

  /** Affichage des applications */
  public tileDisplayConfig: MultiDisplayConfig<FeiKeyDef> = {
    model: this.model,
    datasource: this.measureDS,
    defaultMode: 'tiles',
    onSelectionChanging: this.onSelectionChanging.bind(this),
    onSelectionChanged: this.showDesc.bind(this),
    tiles: {
      enabled: true,
      renderer: AddMeasureRenderer,
      itemHeight: 70,
      itemWidth: 200,
    }
  };

  constructor(public elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super();
  }

  public show(): void {
    super.show();
    let params: MeasureParams = this.datas;
    this.source = params.measure;
    this.mode = params.mode;
    this._model = params.model;
    this.updateCallback = params.callback;
    this.feed();
    this.addListeners();
    // }, 0);
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.measureFilter, WIZ_EVENT_TYPE.FILTER, this.doFilterMeasure); // ecouteur sur le filtre des mesures & function
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_QUICK_SELECT, this.save); // 2x clic sur le header d'un renderer
  }

  /**
   * demande de changement de sélection depuis le multi display
   * @param e wizEvent contenant l'item sélectionné
   */
  private onSelectionChanging(e: WizEvent = null): void {
    // pas de désélection d'un item
    if (this.measureDS.isSelected(e.value)) {
      e.preventDefault();
      return;
    }
  }

  private showDesc(e: WizEvent): void {
    if ((e.value as any).length <= 0) {
      // console.log('nope');
      this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml('');
      this.currentMeasure = null;
    } else {
      const htmlParts: string[] = []; // les lignes pour la construction de la description

      // console.log('showMeas', e.currentTarget, e.target);
      this.currentMeasure = e.value[0] as FeiKeyDef;
      // htmlParts.push('<span class="edit-tool-function">' + this.currentMeasure.fullCode + '</span></br></br>');
      htmlParts.push(
        '<span>' + this.currentMeasure.measure['formula' + this.currentMeasure.mode] + '</span>'
      );
      this.currentDescHtml = this.sanitizer.bypassSecurityTrustHtml(htmlParts.join(''));
    }
  }

  /** alimentation des composants */
  private feed(): void {
    // collecte de toutes les mesures et des WeightGrids
    let keys: FeiKeyDef[] = [];
    const allMeasures: MeasureVO[] = this.model.visionMeasures;
    let keyDef: FeiKeyDef;
    let fei: FeiVO = this.model.measureEngine.currentFEI;
    if (allMeasures) {
      allMeasures.forEach((measure: MeasureVO) => {
  
        if (!!measure.mode) {
          if(measure.mode !== WizConstants.MEASURE_MODE_CONSTANT) {
            measure.mode.split('').forEach((mode: string) => {
              keyDef = BaselineEngine.buildFeiKeyDef(fei, KEY_KIND.MEASURE, measure.source, mode).setParams(false, true, null).setSize(150);
              keys.push(keyDef);
            });
          } else { // les constantes
            keyDef = BaselineEngine.buildFeiKeyDef(fei, KEY_KIND.MEASURE, measure.source, WizConstants.MEASURE_MODE_CONSTANT).setParams(false, true, null).setSize(150);
            keys.push(keyDef);
          }

        }
      });
    }

    // ajout des WGs
    if ( !!this.model.weightGridEngine.getWeightAsMeasureMap()) {
      Array.from(this.model.weightGridEngine.getWeightAsMeasureMap()?.values()).forEach((m:MeasureVO) => {
        keyDef = BaselineEngine.buildFeiKeyDef(fei, KEY_KIND.MEASURE, m.source,  WizConstants.MEASURE_MODE_WEIGHT_GRID).setParams(false, true, null).setSize(150);
        keys.push(keyDef);
      });
    }

    // TODO ajout des constantes

    // construction du filtre des mesures disponibles
    this.measureFilter.configure(['code', 'fullCode'], null, null).build();

    // alimentation de la liste des mesures
    this.measureDS.setSource(keys);
  }

  // filterFunc de la collection de mesures
  protected measureFilterFunc(item: FeiKeyDef): boolean {
    let res: boolean = true;

    if (res) {
      // pas d'ajout de soi-même
      const currMeas: string = [this.source.shortCode, WizConstants.CONTEXT_SEPARATOR, this.mode].join('');
      if (item.fullCode === currMeas) {
        res = false;
      }
    }

    if (res) {
      // seulement si pas déjà filtré
      res = this.measureFilter.checkVisible(item);
    }
    return res;
  }

  /**
   * modification du filtre des mesures
   * @param e WizEvent
   */
  protected doFilterMeasure(e: WizEvent): void {
    this.measureDS.refresh();
  }

  /** validation du contenu */
  public save(e: AlkEvent = null): void {
    // this.doSaveFlag = true;
    this.updateCallback(this.currentMeasure);
    // this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.hide();
    this.updateCallback(null);
  }
}
